// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.editForm .el-form-item .el-form-item__label {\n  font-size: 13px !important;\n  font-weight: 400;\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
